import { TASK_IDS } from "@/shared/constants/taskIds";
import type { FlowScreen, FlowScreenConfig } from "@/shared/constants/flowTypes";

import { createCheckWillScreens } from "./checkWill";
import { createExecutorWitnessesScreens } from "./executorWitnesses";
import { createFamilyTriageScreens } from "./familyTriage";
import { createFamilySignoffsScreens } from "./familySignoffs";

export {
  createCheckWillScreens,
  createExecutorWitnessesScreens,
  createFamilyTriageScreens,
  createFamilySignoffsScreens,
};

export const PROBATE_TASK_IDS = [
  TASK_IDS.PROBATE_CHECK_WILL,
  TASK_IDS.PROBATE_EXECUTOR_WITNESSES,
  TASK_IDS.PROBATE_FAMILY_TRIAGE,
  TASK_IDS.PROBATE_FAMILY_SIGNOFFS,
];

function normalizeScreen(config: FlowScreenConfig): FlowScreen {
  if (!config.question) return config as FlowScreen;
  return { ...config, question: { ...config.question, id: config.id } } as FlowScreen;
}

const TASK_SCREEN_BUILDERS: Record<string, () => FlowScreenConfig[]> = {
  [TASK_IDS.PROBATE_CHECK_WILL]: createCheckWillScreens,
  [TASK_IDS.PROBATE_EXECUTOR_WITNESSES]: createExecutorWitnessesScreens,
  [TASK_IDS.PROBATE_FAMILY_TRIAGE]: createFamilyTriageScreens,
  [TASK_IDS.PROBATE_FAMILY_SIGNOFFS]: createFamilySignoffsScreens,
};

export function buildScreensForTask(taskId: string): FlowScreen[] {
  const builder = TASK_SCREEN_BUILDERS[taskId];
  if (!builder) return [];
  return builder().map(normalizeScreen);
}
